import type { ModuleId } from '@tahi/core';
import type { ComponentType } from 'react';

export interface WebModuleDef {
  id: ModuleId;
  navLabel: string;
  Icon: ComponentType<{ className?: string; 'aria-hidden'?: boolean }>;
  Screen: ComponentType;
}

const mods = new Map<ModuleId, WebModuleDef>();

/** Module plans call this from their own folder (v0.1d: apps/web/src/modules/spending/register.tsx), imported by apps/web/src/modules/index.ts (conventions §15). */
export function registerWebModule(def: WebModuleDef): void {
  mods.set(def.id, def);
}

export function getWebModule(id: ModuleId): WebModuleDef | undefined {
  return mods.get(id);
}

export function listWebModules(): WebModuleDef[] {
  return [...mods.values()];
}

export function unregisterWebModuleForTests(id: ModuleId): void {
  mods.delete(id);
}

export const modulePath = (id: ModuleId): string => `/m/${id}`;
